import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule } from '../../../../../config/config.module';
import {
	MatProgressSpinnerModule,
	MatProgressBarModule
} from '@angular/material';
import { PortletComponent } from './portlet.component';

@NgModule({
	imports: [
		CommonModule,
		ConfigModule,
		MatProgressSpinnerModule,
		MatProgressBarModule
	],
	declarations: [PortletComponent],
	exports: [PortletComponent]
})
export class PortletModule {}
